import { collectCss } from '../../../../../../internal/style-injector/src/index.mjs';

var css$3 = ".GoogleOneTap_module_container__cdc4789a{transition:all .5s ease-out}.GoogleOneTap_module_container__cdc4789a.GoogleOneTap_module_pending__cdc4789a{align-items:center;display:flex;justify-content:center}";
collectCss(css$3);
var modules_f4506a56 = {"container":"GoogleOneTap_module_container__cdc4789a","pending":"GoogleOneTap_module_pending__cdc4789a"};

export { css$3 as css, modules_f4506a56 as default };
//# sourceMappingURL=GoogleOneTap.module.css.mjs.map
